var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.1333C6.10304 2.1333 2.1333 6.10304 2.1333 11C2.1333 15.8969 6.10304 19.8666 11 19.8666C15.8969 19.8666 19.8666 15.8969 19.8666 11C19.8666 6.10304 15.8969 2.1333 11 2.1333ZM9.41666 8.69492V13.3051C9.41666 13.689 9.8314 13.9297 10.1647 13.7392L14.1986 11.4341C14.5345 11.2422 14.5345 10.7578 14.1986 10.5659L10.1647 8.2608C9.8314 8.07032 9.41666 8.31101 9.41666 8.69492Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.3b16ae57383645d27019041a374a0697.svg";
export { ForwardRef as ReactComponent };